import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import { selectIsAuthenticated } from 'store/shipping/shippingSelectors'
import PropTypes from 'prop-types'

const ProtectedRoute = ({ element }) => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const isAuthenticated = useSelector(selectIsAuthenticated)

  if (isAuthenticated === null) {
    return <div>{t('verification_messages.loading')}</div>
  }

  if (!isAuthenticated) {
    return <Navigate to={`/rs/tr/${language}/login`} replace />
  }
  return element
}

ProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
}

export default ProtectedRoute
